
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.81 13.315c.294.082.58-.083.674-.399L10.982.928c.088-.317-.058-.61-.351-.698-.293-.082-.58.082-.674.399L6.465 12.617c-.088.317.053.61.346.697zm5.825-2.127l4.406-3.979a.568.568 0 000-.873l-4.406-3.979c-.24-.228-.575-.222-.78.006-.205.229-.17.557.065.774l4.02 3.633-4.02 3.638c-.235.217-.27.545-.065.774.205.228.54.228.78.005zm-7.828.005c.246.223.574.217.779-.011.205-.229.176-.551-.059-.768l-4.02-3.639 4.02-3.638c.235-.217.264-.54.059-.774-.205-.228-.533-.228-.78-.006L.4 6.336a.576.576 0 000 .873l4.407 3.984z","fill":"#000"}})])
          )
        }
      }
    